import Cookies from 'js-cookie';

export let isMobile = false;
export let isSmartPhone = false;
export let isTablet = false;
export let isiOS = false;
export let isAndroid = false;
export let isMl3App = false;
export let isDeviceId = false;

if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
) {
  isMobile = true;
  if (
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isSmartPhone = true;
  } else if (/iPad/i.test(navigator.userAgent)) {
    isTablet = true;
  }

  if (/Android/i.test(navigator.userAgent)) {
    isAndroid = true;
  } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    isiOS = true;
  }
}

if (Cookies.get('ml3_app') === '1') {
  isMl3App = true;
}

if (Cookies.get('is_device_id') === '1') {
  isDeviceId = true;
}
